/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_ListInputs */

const cs_social_templates_list = /** @type {(inputs: Social_Templates_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablony`)
};

const en_social_templates_list = /** @type {(inputs: Social_Templates_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Social_Templates_ListInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_list = /** @type {((inputs?: Social_Templates_ListInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_ListInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_list(inputs)
	return cs_social_templates_list(inputs)
});